<div class="dialog-container" [class.multi]="isMultiple">
  <h2 mat-dialog-title class="dialog-header">{{ dialogTitle }}</h2>

  <div mat-dialog-content>
    @if (isMultiple) {
      <p class="dialog-message">
        Are you sure you want to remove the following <strong>{{ data.members.length }}</strong> members for year <strong>{{ data.year }}</strong>?
        Optionally provide an End Date@if (anyShowCeoEndDate) {<span> and CEO End Date</span>} for each.
      </p>
    } @else {
      <p class="dialog-message">
        Are you sure you want to remove <strong>{{ data.members[0].name }}</strong> for year <strong>{{ data.year }}</strong>?
      </p>
    }

    <div class="member-grid" [class.with-ceo]="anyShowCeoEndDate">
      @if (isMultiple) {
        <div class="member-grid-header">Name</div>
      } @else {
        <div class="member-grid-header"></div>
      }
      <div class="member-grid-header">End Date</div>
      @if (anyShowCeoEndDate) {
        <div class="member-grid-header">CEO End Date</div>
      }

      @for (m of data.members; track m.id; let i = $index) {
        <div class="member-name">{{ isMultiple ? m.name : '' }}</div>
        <div class="date-cell">
          <input
            type="text"
            class="ht-date-input"
            placeholder="dd/mm/yyyy"
            maxlength="10"
            [value]="endDateDisplays[i]"
            (input)="onDateInput($event, i, 'endDate')"
            (focus)="onDateFocus($event)"
            (blur)="onDateBlur($event, i, 'endDate')" />
        </div>
        @if (anyShowCeoEndDate) {
          <div class="date-cell">
            @if (m.showCeoEndDate) {
              <input
                type="text"
                class="ht-date-input"
                placeholder="dd/mm/yyyy"
                maxlength="10"
                [value]="ceoEndDateDisplays[i]"
                (input)="onDateInput($event, i, 'ceoEndDate')"
                (focus)="onDateFocus($event)"
                (blur)="onDateBlur($event, i, 'ceoEndDate')" />
            } @else {
              <span class="na">—</span>
            }
          </div>
        }
      }
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-flat-button type="button" class="nrg-error-raised-button" (click)="onCancel()">
      <mat-icon>close</mat-icon>
      Cancel
    </button>
    <button mat-raised-button color="primary" (click)="onConfirm()">
      <mat-icon>delete</mat-icon>
      Delete
    </button>
  </div>
</div>
